import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = {
  class: "d-flex flex-row border-1 pt-5 px-3",
  style: {"margin-left":"30px","margin-right":"30px","border-style":"solid !important"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-3 px-3",
  style: {"font-size":"larger","font-weight":"500","margin-top":"5px"}
}, " Rangkuman Tabel ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 px-3" }, null, -1)
const _hoisted_5 = { class: "col-7 px-3 row" }
const _hoisted_6 = { class: "col-3 card-title d-flex flex-column align-items-center text-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted fw-bolder fs-7 mb-1" }, "Jumlah Kartu", -1)
const _hoisted_8 = {
  class: "mt-1 fw-bold fs-7",
  style: {"color":"#3268ff"}
}
const _hoisted_9 = { class: "col-3 card-title d-flex flex-column align-items-center text-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted fw-bolder fs-7 mb-1" }, "Jumlah Digunakan", -1)
const _hoisted_11 = {
  class: "mt-1 fw-bold fs-7",
  style: {"color":"#00a29c"}
}
const _hoisted_12 = { class: "col-3 card-title d-flex flex-column align-items-center text-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted fw-bolder fs-7 mb-1" }, "Jumlah Blank", -1)
const _hoisted_14 = { class: "mt-1 fw-bold fs-7" }
const _hoisted_15 = { class: "col-3 card-title d-flex flex-column align-items-center text-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted fw-bolder fs-7 mb-1" }, "Jumlah Gagal", -1)
const _hoisted_17 = {
  class: "mt-1 fw-bold fs-7",
  style: {"color":"#e50200"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center position-relative my-1" }, null, -1)
const _hoisted_19 = { class: "card-header border-0 pt-5" }
const _hoisted_20 = { class: "col-12 pt-5" }
const _hoisted_21 = { class: "d-grid gap-2 d-md-flex justify-content-md-start" }
const _hoisted_22 = { class: "container px-0" }
const _hoisted_23 = { class: "row fv-row mb-2 mt-5" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_25 = {
  key: 0,
  class: "col-sm-1 col-md-2 mb-1"
}
const _hoisted_26 = { class: "d-flex align-items-center position-relative" }
const _hoisted_27 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_28 = {
  key: 1,
  class: "col-sm-7 mb-1"
}
const _hoisted_29 = { class: "align-items-center position-relative" }
const _hoisted_30 = {
  key: 2,
  class: "col-sm-6 col-md-3 mt-2"
}
const _hoisted_31 = { class: "d-flex align-items-center position-relative" }
const _hoisted_32 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_33 = {
  key: 3,
  class: "col-sm-3 col-md-2 mb-1 mt-2",
  style: {"width":"20%"}
}
const _hoisted_34 = { class: "d-flex align-items-center position-relative" }
const _hoisted_35 = { class: "card-body py-3" }
const _hoisted_36 = { class: "table-responsive" }
const _hoisted_37 = { class: "table align-middle gs-0 gy-4 table-striped table-hover" }
const _hoisted_38 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "NFC ID", -1)
const _hoisted_40 = {
  key: 0,
  class: "min-w-125px; text-center"
}
const _hoisted_41 = {
  key: 1,
  class: "min-w-125px; text-center"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal Mapping", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama Sekolah", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama Pengguna", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal Aktif", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi", -1)
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "text-left" }
const _hoisted_50 = {
  key: 0,
  class: "text-left"
}
const _hoisted_51 = {
  key: 1,
  class: "text-center"
}
const _hoisted_52 = { class: "text-center" }
const _hoisted_53 = { class: "text-center" }
const _hoisted_54 = { class: "text-center" }
const _hoisted_55 = {
  key: 2,
  class: "text-center"
}
const _hoisted_56 = {
  key: 3,
  class: "text-center"
}
const _hoisted_57 = {
  key: 0,
  class: "text-center badge badge-danger"
}
const _hoisted_58 = {
  key: 1,
  class: "text-center badge badge-success"
}
const _hoisted_59 = {
  key: 2,
  class: "text-center badge badge-primary"
}
const _hoisted_60 = {
  key: 3,
  class: "text-center badge badge-warning"
}
const _hoisted_61 = { class: "text-left" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/edit.svg",
  alt: ""
}, null, -1)
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = { key: 1 }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "12",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = { class: "row mt-5 mb-5" }
const _hoisted_75 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_76 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_77 = ["label", "value"]
const _hoisted_78 = { class: "p-3" }
const _hoisted_79 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_80 = { class: "pagination" }
const _hoisted_81 = { class: "row mt-5 mb-5" }
const _hoisted_82 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_2"
}
const _hoisted_83 = { class: "modal-dialog" }
const _hoisted_84 = { class: "modal-content" }
const _hoisted_85 = { class: "modal-header" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("h2", { class: "modal-title justify-content-center mb-7" }, " Edit Data Kartu ", -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_88 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_89 = { class: "svg-icon svg-icon-2x" }
const _hoisted_90 = { class: "modal-body row" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 text-start bd-highlight",
  style: {"font-size":"medium"}
}, " Nama Sekolah ", -1)
const _hoisted_92 = { class: "p-3 col-12 bd-highlight" }
const _hoisted_93 = { class: "col-12" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 text-start bd-highlight",
  style: {"font-size":"medium"}
}, " Nama Pengguna ", -1)
const _hoisted_95 = { class: "p-3 col-12 bd-highlight" }
const _hoisted_96 = { class: "col-12" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 text-start bd-highlight",
  style: {"font-size":"medium"}
}, " NFC id ", -1)
const _hoisted_98 = { class: "p-3 col-12 bd-highlight" }
const _hoisted_99 = { class: "col-12" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-12 text-start bd-highlight required",
  style: {"font-size":"medium"}
}, " Pilih Status ", -1)
const _hoisted_101 = { class: "p-3 bd-highlight" }
const _hoisted_102 = { class: "col-12" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Status", -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("option", {
  value: "LOST",
  key: "lost"
}, "HILANG", -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("option", {
  value: "DAMAGED",
  key: "damaged"
}, "RUSAK", -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("option", {
  value: "REPLACEMENT",
  key: "replacement"
}, " SALAH MAPPING ", -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 text-start bd-highlight required",
  style: {"font-size":"medium"}
}, " NFC id Baru ", -1)
const _hoisted_108 = { class: "p-3 col-12 bd-highlight" }
const _hoisted_109 = { class: "col-12" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-12 text-start bd-highlight",
  style: {"font-size":"medium"}
}, " Alasan Diganti ", -1)
const _hoisted_111 = { class: "p-3 bd-highlight" }
const _hoisted_112 = { class: "col-12" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("span", { class: "pt-5" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#e50200"} }, "* wajib diisi")
], -1)
const _hoisted_114 = { class: "modal-footer" }
const _hoisted_115 = { class: "text-center" }
const _hoisted_116 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_117 = { class: "row mt-5 mb-5" }
const _hoisted_118 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_3"
}
const _hoisted_119 = { class: "modal-dialog" }
const _hoisted_120 = { class: "modal-content" }
const _hoisted_121 = { class: "modal-header" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("h2", { class: "modal-title justify-content-center mb-7" }, " Detail Data Kartu ", -1)
const _hoisted_123 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_124 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_125 = { class: "svg-icon svg-icon-2x" }
const _hoisted_126 = { class: "modal-body row" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 text-start bd-highlight",
  style: {"font-size":"medium"}
}, " Nama Sekolah ", -1)
const _hoisted_128 = {
  key: 0,
  class: "p-3 col-12 bd-highlight"
}
const _hoisted_129 = { class: "col-12" }
const _hoisted_130 = {
  key: 1,
  class: "p-3 col-12 bd-highlight"
}
const _hoisted_131 = { class: "col-12" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 text-start bd-highlight",
  style: {"font-size":"medium"}
}, " Nama Pengguna ", -1)
const _hoisted_133 = {
  key: 2,
  class: "p-3 col-12 bd-highlight"
}
const _hoisted_134 = { class: "col-12" }
const _hoisted_135 = {
  key: 3,
  class: "p-3 col-12 bd-highlight"
}
const _hoisted_136 = { class: "col-12" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 text-start bd-highlight",
  style: {"font-size":"medium"}
}, " NFC id ", -1)
const _hoisted_138 = { class: "p-3 col-12 bd-highlight" }
const _hoisted_139 = { class: "col-12" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 text-start bd-highlight",
  style: {"font-size":"medium"}
}, " Alasan Diganti ", -1)
const _hoisted_141 = { class: "p-3 col-12 bd-highlight" }
const _hoisted_142 = { class: "col-12" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "button",
      class: "btn btn-primary",
      "data-bs-dismiss": "modal"
    }, " Kembali"),
    /*#__PURE__*/_createTextVNode("  ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.totalCardSuccess), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.totalCardActive), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.totalCardBlank), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.totalCardFailed), 1)
        ]),
        _hoisted_18
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args))),
              class: "btn btn-md btn-primary"
            }, " Download ")
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", {
              class: "col-sm-1 px-5 btn btn-md btn-light",
              style: {"font-size":"medium","font-weight":"400","margin-top":"0px"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterClick && _ctx.filterClick(...args)))
            }, " Filter "),
            (_ctx.filter == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("span", _hoisted_27, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control ps-15",
                      placeholder: "Cari NFC id",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nfcId) = $event)),
                      onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePageSize(_ctx.e)))
                    }, null, 544), [
                      [_vModelText, _ctx.nfcId]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.roleuser !== 'ADMIN_SCHOOL' && _ctx.filter == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.schoolId,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.schoolId) = $event)),
                      placeholder: "Pilih Nama Sekolah",
                      mode: "single",
                      "create-option": false,
                      options: _ctx.listSekolah,
                      searchable: true,
                      label: "name",
                      "track-by": "name",
                      "value-prop": "_id",
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.pilihSekolah($event)))
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.filter == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("span", _hoisted_32, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control ps-15",
                      placeholder: "Nama Pengguna",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.accountName) = $event)),
                      onKeyup: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changePageSize(_ctx.e)))
                    }, null, 544), [
                      [_vModelText, _ctx.accountName]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.filter == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.cardStatus,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.cardStatus) = $event)),
                      placeholder: "Status",
                      mode: "single",
                      "create-option": false,
                      options: _ctx.combostatus,
                      searchable: true,
                      label: "name",
                      "track-by": "name",
                      "value-prop": "_id",
                      onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.pilihstatus($event)))
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("table", _hoisted_37, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_38, [
                _hoisted_39,
                (_ctx.roleuser != 'ADMIN_SCHOOL')
                  ? (_openBlock(), _createElementBlock("th", _hoisted_40, " Nama Merchant "))
                  : _createCommentVNode("", true),
                (_ctx.roleuser != 'ADMIN_SCHOOL')
                  ? (_openBlock(), _createElementBlock("th", _hoisted_41, " Tanggal Beli "))
                  : _createCommentVNode("", true),
                _hoisted_42,
                _hoisted_43,
                _hoisted_44,
                _hoisted_45,
                _hoisted_46,
                _hoisted_47
              ])
            ]),
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_48, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_49, _toDisplayString(item.nfcId), 1),
                      (_ctx.roleuser != 'ADMIN_SCHOOL')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_50, _toDisplayString(item.merchantName), 1))
                        : _createCommentVNode("", true),
                      (_ctx.roleuser != 'ADMIN_SCHOOL')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_51, _toDisplayString(_ctx.formatDate(item.purchaseDate)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.dateTime2(item.mappingDate)), 1),
                      _createElementVNode("td", _hoisted_53, _toDisplayString(item.schoolName), 1),
                      _createElementVNode("td", _hoisted_54, _toDisplayString(item.accountName), 1),
                      (item.activateDate === '' || item.activateDate === null)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_55, _toDisplayString("")))
                        : (_openBlock(), _createElementBlock("td", _hoisted_56, _toDisplayString(_ctx.dateTime2(item.activateDate)), 1)),
                      _createElementVNode("td", null, [
                        (item.cardStatus == 'DAMAGED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_57, " RUSAK "))
                          : _createCommentVNode("", true),
                        (item.cardStatus == 'ACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_58, " AKTIF "))
                          : _createCommentVNode("", true),
                        (item.cardStatus == 'INACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_59, " BELUM DIGUNAKAN "))
                          : _createCommentVNode("", true),
                        (item.cardStatus == 'LOST')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_60, " HILANG "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_61, [
                        _createElementVNode("a", {
                          class: "symbol symbol-35px me-2",
                          title: "Detail",
                          onClick: ($event: any) => (_ctx.getId(index, item)),
                          style: {"cursor":"pointer"},
                          "data-bs-target": "#kt_modal_3",
                          "data-bs-toggle": "modal"
                        }, _hoisted_64, 8, _hoisted_62),
                        (item.accountName !== null)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "symbol symbol-35px me-2",
                              title: "Edit",
                              onClick: ($event: any) => (_ctx.getId(index, item)),
                              style: {"cursor":"pointer"},
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#kt_modal_2"
                            }, _hoisted_67, 8, _hoisted_65))
                          : _createCommentVNode("", true),
                        _createElementVNode("a", {
                          class: "symbol symbol-35px me-2",
                          "data-bs-toggle": "tooltip",
                          title: "Hapus",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.handleDelete(index, item))
                        }, _hoisted_70, 8, _hoisted_68)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_71, _hoisted_73))
          ])
        ]),
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_77))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_78, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("ul", _hoisted_80, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_81, [
        _createElementVNode("div", _hoisted_82, [
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, [
                _hoisted_86,
                _hoisted_87,
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("span", _hoisted_89, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_90, [
                _hoisted_91,
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("div", _hoisted_93, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "schoolName",
                      class: "form-control form-control-lg",
                      modelValue: _ctx.formDetail.schoolName,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formDetail.schoolName) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _hoisted_94,
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("div", _hoisted_96, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "accountName",
                      class: "form-control form-control-lg",
                      modelValue: _ctx.formDetail.accountName,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formDetail.accountName) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _hoisted_97,
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("div", _hoisted_99, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "nfcId",
                      class: "form-control form-control-lg",
                      modelValue: _ctx.formDetail.nfcId,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formDetail.nfcId) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _hoisted_100,
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("div", _hoisted_102, [
                    _createVNode(_component_Field, {
                      as: "select",
                      class: "form-select form-select-lg fw-bold",
                      name: "status",
                      placeholder: "Pilih Status",
                      autocomplete: "off",
                      modelValue: _ctx.formDetail.cardStatus,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formDetail.cardStatus) = $event))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_103,
                        _hoisted_104,
                        _hoisted_105,
                        _hoisted_106
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _hoisted_107,
                _createElementVNode("div", _hoisted_108, [
                  _createElementVNode("div", _hoisted_109, [
                    _createVNode(_component_Field, {
                      type: "int",
                      name: "nfcIdbaru",
                      placeholder: "NFC id Baru wajib diisi",
                      class: "form-control form-control-lg",
                      modelValue: _ctx.formDetail.nfcIdbaru,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formDetail.nfcIdbaru) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _hoisted_110,
                _createElementVNode("div", _hoisted_111, [
                  _createElementVNode("div", _hoisted_112, [
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-lg",
                      name: "note",
                      modelValue: _ctx.formDetail.note,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formDetail.note) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _hoisted_113
              ]),
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("span", _hoisted_115, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
                  }, " Batal"),
                  _hoisted_116,
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args)))
                  }, " Simpan ")
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_117, [
          _createElementVNode("div", _hoisted_118, [
            _createElementVNode("div", _hoisted_119, [
              _createElementVNode("div", _hoisted_120, [
                _createElementVNode("div", _hoisted_121, [
                  _hoisted_122,
                  _hoisted_123,
                  _createElementVNode("div", _hoisted_124, [
                    _createElementVNode("span", _hoisted_125, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_126, [
                  _hoisted_127,
                  (_ctx.formDetail.schoolName == 'Unregisterd')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                        _createElementVNode("div", _hoisted_129, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control form-control-lg",
                            disabled: "",
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formDetail.schoolName2) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.formDetail.schoolName2]
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_130, [
                        _createElementVNode("div", _hoisted_131, [
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "schoolName",
                            class: "form-control form-control-lg",
                            modelValue: _ctx.formDetail.schoolName,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formDetail.schoolName) = $event)),
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ])
                      ])),
                  _hoisted_132,
                  (_ctx.formDetail.accountName == 'Unregistered')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                        _createElementVNode("div", _hoisted_134, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control form-control-lg",
                            disabled: "",
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formDetail.accountName2) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.formDetail.accountName2]
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_135, [
                        _createElementVNode("div", _hoisted_136, [
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "accountName",
                            class: "form-control form-control-lg",
                            modelValue: _ctx.formDetail.accountName,
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formDetail.accountName) = $event)),
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ])
                      ])),
                  _hoisted_137,
                  _createElementVNode("div", _hoisted_138, [
                    _createElementVNode("div", _hoisted_139, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "nfcId",
                        class: "form-control form-control-lg",
                        modelValue: _ctx.formDetail.nfcId,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formDetail.nfcId) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_140,
                  _createElementVNode("div", _hoisted_141, [
                    _createElementVNode("div", _hoisted_142, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "note",
                        class: "form-control form-control-lg",
                        modelValue: _ctx.formDetail.note,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formDetail.note) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _hoisted_143
              ])
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}